import { createMedia } from '@artsy/fresnel';

export const breakpoints = {
  mobile: 320,
  tablet: 768,
  computer: 1024,
};

const AppMedia = createMedia({ breakpoints });

export const mediaStyles = AppMedia.createMediaStyle();
export const { Media, MediaContextProvider } = AppMedia;

// This is outdated, but it's still used within a couple of files
// TODO - Recommend to remove thiese old breakpoints and adapt with the breakpoints above
export const oldBreakpoints = {
  extraSmall: 550,
  medium: 1100,
};
